import instance from './instance.js'
import statuses from './statuses.js'
import notifications from './notifications.js'
import users from './users.js'
import api from './api.js'
import config from './config.js'
import profileConfig from './profileConfig.js'
import serverSideStorage from './serverSideStorage.js'
import adminSettings from './adminSettings.js'
import authFlow from './auth_flow.js'
import oauthTokens from './oauth_tokens.js'
import drafts from './drafts.js'
import chats from './chats.js'

export default {
  instance,
  statuses,
  notifications,
  users,
  api,
  config,
  profileConfig,
  serverSideStorage,
  adminSettings,
  authFlow,
  oauthTokens,
  drafts,
  chats
}
